import { getByID } from '@adornis/baseql/operations/mongo.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@adornis/chemistry/elements/components/x-grid.js';
import { currentUser } from '@adornis/users/client/currentUser.js';
import '@ils/osces/client/ils-osce-overview.js';
import { OSCE } from '@ils/osces/db/osce.js';
import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { combineLatest, from, of, switchMap } from 'rxjs';
import type { ILSUser } from '../../db/ils-user.js';
import '../components/ils-view-osce.js';

/**
 * @element ils-view-osces
 */
@customElement('ils-view-osces')
export class ILSViewOsces extends ChemistryLitElement {
  @property({ attribute: 'osce-id' }) readonly osceID = new RXController(this, '');
  @property({ type: Boolean, attribute: 'editable' }) editable = false;

  @state() private readonly _osce = new RXController(
    this,
    combineLatest([this.osceID.observable, currentUser<ILSUser>()]),
    obs$ =>
      obs$.pipe(
        switchMap(([osceID, user]) =>
          user && osceID
            ? from(
                getByID(
                  OSCE,
                  osceID,
                )({
                  title: 1,
                  titleTrainee: 1,
                  osceType: 1,
                  taskType: 1,
                  conversationType: 1,
                  startButtonDuration: 1,
                  enableVideo: 1,
                  durationInMinutes: 1,
                  videoFileID: 1,
                  text: {
                    shortDescription: 1,
                    sceneDescriptionTrainee: 1,
                    taskDescriptionTrainee: 1,
                    sceneDescriptionTester: 1,
                  },
                  instructionCategories: { description: 1, instructions: { question: 1, description: 1 } },
                  isRatedAtLeastOnce: 1,
                }),
              )
            : of(null),
        ),
      ),
  );

  override render() {
    if (this.osceID.value) return this._viewOsce();

    return html` <ils-osce-overview ?editable=${this.editable}> </ils-osce-overview> `;
  }

  private _viewOsce() {
    if (this._osce.isLoading)
      return html`<x-flex center crossaxis-center ${css({ height: '100%' })}> <ils-loader></ils-loader> </x-flex>`;
    return html` <ils-view-osce show-back .osce=${this._osce.value}></ils-view-osce> `;
  }
}
